<app-dialog #dialog
            (cancel)="cancelClicked()"
            (confirm)="returnClicked()"
            cancelButtonText="Cancel"
            confirmButtonText="Return"
            confirmButtonColor="warn"
            title="Are you sure you want to navigate away?">
  <p>Any changes made will be lost</p>
</app-dialog>
